// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_play__0ow3h{
    display: flex;
    justify-content: flex-start;
    align-items:center;
    height:auto;

}

.styles_player__xRAkq {
    /* width: 100%; */
    display: flex;
    justify-content: flex-end;
    align-items:center;
    height:auto;

  
  /* background: #ababab; */
  /* background-color: #abababbd;
  border-radius: 23px;
  */
  /* background-color: rgb(218 215 215 / 74%);
    border-radius: 7px; */
    /* background-color: rgb(189 173 173 / 74%);
    border-radius: 8px; */
  margin-right: 10px;
  margin-left: 10px;
  }
  .styles_controls__hOip- {
    display: flex;
    justify-content: flex-start;
    align-items:center;
    /* width:100%; */
    height:auto;
    direction:ltr;
  }
  .styles_icon__1zEAk{
    margin-right:5px;
    cursor:pointer;
  }
  .styles_hiddenSeekbar__uRj-C{
    /* width:0px; */
    visibility: hidden;
    /* position:absolute;
    z-index:-1000; */
  }`, "",{"version":3,"sources":["webpack://./../src/renderer/components/HiddenAudioPlayer/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;;AAEf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;;;EAGb,yBAAyB;EACzB;;GAEC;EACD;yBACuB;IACrB;yBACqB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB;oBACgB;EAClB","sourcesContent":[".play{\n    display: flex;\n    justify-content: flex-start;\n    align-items:center;\n    height:auto;\n\n}\n\n.player {\n    /* width: 100%; */\n    display: flex;\n    justify-content: flex-end;\n    align-items:center;\n    height:auto;\n\n  \n  /* background: #ababab; */\n  /* background-color: #abababbd;\n  border-radius: 23px;\n  */\n  /* background-color: rgb(218 215 215 / 74%);\n    border-radius: 7px; */\n    /* background-color: rgb(189 173 173 / 74%);\n    border-radius: 8px; */\n  margin-right: 10px;\n  margin-left: 10px;\n  }\n  .controls {\n    display: flex;\n    justify-content: flex-start;\n    align-items:center;\n    /* width:100%; */\n    height:auto;\n    direction:ltr;\n  }\n  .icon{\n    margin-right:5px;\n    cursor:pointer;\n  }\n  .hiddenSeekbar{\n    /* width:0px; */\n    visibility: hidden;\n    /* position:absolute;\n    z-index:-1000; */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"play": `styles_play__0ow3h`,
	"player": `styles_player__xRAkq`,
	"controls": `styles_controls__hOip-`,
	"icon": `styles_icon__1zEAk`,
	"hiddenSeekbar": `styles_hiddenSeekbar__uRj-C`
};
export default ___CSS_LOADER_EXPORT___;
